<template>
  <DialogLayout v-model:show="dialogVisible" height="600px" title="陪练背景" width="800px">
    <PracticeBackground
      :practice-content="practiceContent"
      :task-name="taskName"
    ></PracticeBackground>
  </DialogLayout>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { getPracticeContent } from '@/api/ai-board.js'
import DialogLayout from '@/components/layout/dialog-layout/index.vue'
import PracticeBackground from '../practice-background/index.vue'

defineOptions({
  name: 'PracticeBackgroundDialog'
})

const emit = defineEmits(['update:show'])

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  params: {
    type: Object,
    default: () => ({})
  }
})

const practiceContent = ref({})
const requestLoading = ref(false)

const normalizePracticeContent = (content = {}) => {
  const customerChat = Array.isArray(content.customerChat)
    ? content.customerChat
    : [content.customerChat]

  return {
    practiceTopic: content.practiceTopic || '',
    practiceTopicDesc: content.practiceTopicDesc || '',
    background: content.background || '',
    initialAttitude: content.initialAttitude || '',
    trainingGoal: content.trainingGoal || '',
    customerName: content.customerName || '',
    customerProfile: content.customerProfile || '',
    customerChat: customerChat.filter((item) => String(item ?? '').trim())
  }
}

const dialogVisible = computed({
  get: () => props.show,
  set: (value) => emit('update:show', value)
})

const taskName = computed(() => props.params?.taskName || props.params?.themeName || '')

const resetPracticeContent = () => {
  practiceContent.value = {}
}

const getPracticeBackgroundParams = () => {
  if (props.params?.practiceRecordId) {
    return {
      practiceRecordId: props.params.practiceRecordId
    }
  }

  if (props.params?.themeTaskId) {
    return {
      taskType: 2,
      taskId: props.params.themeTaskId
    }
  }

  if (props.params?.taskId) {
    return {
      taskType: 1,
      taskId: props.params.taskId
    }
  }

  return null
}

const getPracticeBackground = () => {
  const requestParams = getPracticeBackgroundParams()
  if (!requestParams || requestLoading.value) return

  requestLoading.value = true
  getPracticeContent(requestParams)
    .then((res) => {
      practiceContent.value = normalizePracticeContent(res.result?.practiceContent)
    })
    .finally(() => {
      requestLoading.value = false
    })
}

watch(
  () => props.show,
  (visible) => {
    if (visible) {
      getPracticeBackground()
      return
    }

    resetPracticeContent()
  }
)
</script>

<style lang="less" scoped></style>
